import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActionType } from '@app/shared/enums';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: 'confirmation-dialog.component.html',
  styleUrls: ['confirmation-dialog.component.scss'],
})
export class ConfirmationDialogComponent {
  public title: string;
  public status: string;
  public description: string;
  public descriptionSubText: string;
  public descriptionSubText1: string;
  public descriptionSubText2: string;
  public confirmText: string;
  public declineText: string;
  public readingUploaded: string;
  public closeButton = false;
  public phoneNumber: number;
  public emailAddress: string;
  public actionType?: ActionType;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    public overlayLoader: OverlayLoaderService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.title = this.data.title;
    this.status = this.data.status;
    this.description = this.data.description;
    this.descriptionSubText = this.data.descriptionSubText;
    this.descriptionSubText1 = this.data.descriptionSubText1;
    this.descriptionSubText2 = this.data.descriptionSubText2;
    this.confirmText = this.data.confirmText;
    this.declineText = this.data.declineText;
    this.readingUploaded = this.data.readingUploaded;
    this.closeButton = this.data.closeButton;
    this.phoneNumber = this.data.phoneNumber;
    this.emailAddress = this.data.emailAddress;
    this.actionType = this.data.actionType;
  }

  back() {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
